import { render } from "./button.vue?vue&type=template&id=1c698233&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=1c698233&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c698233"]])

export default __exports__